import { g as f } from "./_commonjsHelpers-OnjxAlhP.js";
import { useState as o, useEffect as u, useCallback as m } from "react";
const g = (t, r) => {
  const [n, s] = o(!1), [a, i] = o(t);
  u(() => {
    var e;
    n || a === t || ((e = f().window) != null && e.matchMedia("(prefers-reduced-motion: reduce)").matches ? i(t) : requestAnimationFrame(() => s(!0)));
  }, [n, a, t]);
  const c = m(
    (e) => {
      e.stopPropagation(), e.target === e.currentTarget && (!r || r.includes(e.propertyName)) && requestAnimationFrame(() => s(!1));
    },
    [r]
  );
  return u(() => {
    n && requestAnimationFrame(() => i(t));
  }, [n, t]), [n, a, c];
};
export {
  g as u
};
